import React, { useState, useEffect } from 'react';
import { Box, FormControl, OutlinedInput} from "@mui/material";
import { MultiSelect } from "react-multi-select-component";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Alert from '@mui/material/Alert';
import { columns ,disablecolumns} from "./Column";
import "./Table.css";
import api from "../api/http-common";
import { catergory, district } from "./DATA";
import Button from '@mui/material/Button';
import { DataGrid } from '@mui/x-data-grid';
import Popover from '@mui/material/Popover';
import CircularProgress from '@mui/material/CircularProgress';
import { TableContainer } from '@mui/material';
import { grey } from '@mui/material/colors'; // Import grey color from Material-UI
import { useMediaQuery } from "@mui/material";
import { SparkLineChart,LineChart } from '@mui/x-charts';
import {Modal,ModalContent} from './ModelData'
import Fade from '@mui/material/Fade';
import axios from "axios";
import loadingImg from "../assert/loadingimg.png";


const style = {
  model: {
    width: {  sm: "450px", md:"450px" },
    m: 1.5,
  },
  formControl: {
    width: { xs: "100%", sm: "100%", md: "250px" },
    m: 1.5,
  },
  formControlFullWidth: {
    width: { xs: "100%", sm: "100% ", md: "525px"},
    m: 1.5,
  },
  formControlOther: {
    width: { xs: "100%", sm: "100%", md: "250px" },  // Other columns width
    m: 1.5,
  },
  formControlCutoffRank: {
    width: { xs: "150px", sm: "100%", md: "250px" },  // Other columns width
    m: 1.5,
  },
  label: {
    color: "#000",
    fontWeight: 600,
    // fontFamily: "var(--font-family)",
    "&.MuiInputLabel-outlined.MuiInputLabel-shrink": {
      color: "grey",
      fontSize: "20px",
      // fontFamily: "var(--font-family)",
      ontWeight: "bold",
    },
  },
  inputFiled: {
    color: "#000",
    background: "#FFFFFF",
    fontSize: "16px",
    height:'40px',
    // fontFamily: "var(--font-family)",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey",
    },
    "&:hover > .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey",
    },
  },
};

export function Eligibility() {
  
  const [selectCategory, setSelectCategory] = useState(null);
  const [error, setError] = useState(false);
  const [selectCutoff, setSelectCutoff] = useState(null);
  const [selectRank, setSelectRank] = useState(null);
  const [selectCollegeCode, setSelectCollegeCode] = useState([]);
  const [selectCollegeName, setSelectCollegeName] = useState([]);
  const [selectBranchCode, setSelectBranchCode] = useState([]);
  const [selectBranchName, setSelectBranchName] = useState([]);
  const [selectDistrict, setSelectDistrict] = useState([]);
  const [selectPincode, setSelectPincode] = useState('');
  const [branchName, setBranchName] = useState([]);
  const [branchCode, setBranchCode] = useState([]);
  const [collegeName, setCollegeName] = useState([]);
  const [collegeCode, setCollegeCode] = useState([]);
  const [cutoffList, setCutoffList] = useState([]);
  const [filteredCutoffList, setFilteredCutoffList] = useState([]);
  const [cursorloading, setcursorLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [displayGrid,setDisplayGrid]= useState(false);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [data,setData]= useState([]);
  const [subdata,setSubData]= useState([]);
  const [curcollege,setcurCollege]=useState('');
  const [curbranch,setcurbranch]=useState('');
  const [curfield,setcurfield]=useState('');
  const [curcategory,setcurcategory]=useState('');
  const [y25cutoff, sety25cutoff] = React.useState();
  const [y24cutoff, sety24cutoff] = React.useState();
  const [y23cutoff, sety23cutoff] = React.useState();
  const [y22cutoff, sety22cutoff] = React.useState();
  const [y21cutoff, sety21cutoff] = React.useState();
  const [y20cutoff, sety20cutoff] = React.useState();
  const [y19cutoff, sety19cutoff] = React.useState();
  const [modelopen, setModelOpen] = React.useState(false);
  const [connectNulls, setConnectNulls] = React.useState(true);
  const [eligibilityData, setEligibilityData] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);

  
  console.log(y23cutoff)
//  const handleOpen = (params) => {

//   const { field, row } = params;

//   const notAllowedColumns = ['id', 'college_code', 'college_name', 'branch_code', 'branch_name'];

//   if (!notAllowedColumns.includes(field) && field.startsWith('y2025')) {
//     const { college_code, branch_code,college_name,branch_name } = row;
//       setcurCollege(college_name);
//       setcurbranch(branch_name);
     
//     if (!college_code || !branch_code) {
//       console.error('college_code or branch_code is undefined or blank:');
//       setData([0, 0, 0, 0, 0, 0, 0]);
//       setModelOpen(true);
//       return;
//     }

//     const categoryValue = field.substring(field.indexOf("y2025_") + 6, field.lastIndexOf("_"));
//     setcurcategory(categoryValue);
//     if(field.endsWith('cutoff')) {setcurfield('Cutoff')}else{setcurfield('Rank')}
//     const cutoffData = [
//        { year: '2025', list: y24cutoff },
//       { year: '2024', list: y24cutoff },
//       { year: '2023', list: y23cutoff },
//       { year: '2022', list: y22cutoff },
//       { year: '2021', list: y21cutoff },
//       { year: '2020', list: y20cutoff },
//       { year: '2019', list: y19cutoff }
//     ];

    
//   if(field.endsWith('cutoff') ){
//     const yearFields = [
//       `y2025_${categoryValue}_cutoff`,
//       `y2024_${categoryValue}_cutoff`,
//       `y2023_${categoryValue}_cutoff`,
//       `y2022_${categoryValue}_cutoff`,
//       `y2021_${categoryValue}_cutoff`,
//       `y2020_${categoryValue}_cutoff`,
//       `y2019_${categoryValue}_cutoff`
//     ];

//     const collegeBranchCutoffs = cutoffData.map((data, index) => {
//       const yearField = yearFields[index];
//       const cutoffList = data.list;
//       // const cutoffItem = cutoffList.find(item => item.college_code === college_code && item.branch_code === branch_code);
//       const cutoffItem = Array.isArray(cutoffList)
//   ? cutoffList.find(item => item.college_code === college_code && item.branch_code === branch_code)
//   : null;
//       // console.log(cutoffItem)
//       const r= {
//         year: data.year,
//         cutoff: cutoffItem && cutoffItem[yearField] !== undefined ? cutoffItem[yearField] : 0
//       };
//       return r;
//     });

//     collegeBranchCutoffs.sort((a, b) => a.year - b.year);
//     const cutoffs = collegeBranchCutoffs.map(item => {
//       const cutoff = item.cutoff;
//       return (cutoff === 0.0 || cutoff ===0) ? null : cutoff;
//     });
//     console.log(":):):)",cutoffs)
//     const nonZeroCutoffs = cutoffs.filter(item => item !== null && item!=="");
//     const average = nonZeroCutoffs.reduce((sum, value) => sum + value, 0) / nonZeroCutoffs.length;
//     setData(cutoffs);
    
//     if (average) {
//       setSubData(Array(7).fill(average));
    
//   } else {
//       console.error('Item not found');
//   }
//   }
//   else{
//     const yearFields = [
//        `y2025_${categoryValue}_rank`,
//        `y2024_${categoryValue}_rank`,
//       `y2023_${categoryValue}_rank`,
//       `y2022_${categoryValue}_rank`,
//       `y2021_${categoryValue}_rank`,
//       `y2020_${categoryValue}_rank`,
//       `y2019_${categoryValue}_rank`
//     ];

//     const collegeBranchCutoffs = cutoffData.map((data, index) => {
//       const yearField = yearFields[index];
//       const trankList = data.list;
//       const rankItem = trankList.find(item => item.college_code === college_code && item.branch_code === branch_code);
//       const r= {
//         year: data.year,
//         rank: rankItem && rankItem[yearField] !== undefined ? rankItem[yearField] : 0
//       };
//       return r;
//     });

//     collegeBranchCutoffs.sort((a, b) => a.year - b.year);
//     const cutoffs = collegeBranchCutoffs.map(item => {
//       const rank = item.rank;
//       return (rank === 0.0 || rank ===0) ? null : rank;
//     });
//     const nonZeroCutoffs = cutoffs.filter(item => item !== null&& item!=="");
//     const average = nonZeroCutoffs.reduce((sum, value) => sum + value, 0) / nonZeroCutoffs.length;
//     setData(cutoffs);

//     if (average) {
//       setSubData(Array(7).fill(average)); 
//   } else {
//       console.error('Item not found');
//   }
//   } 
//   console.log(subdata)
//     setModelOpen(true);
//   }
// };

const handleOpen = (params) => {
  const { field, row } = params;

  const notAllowedColumns = ['id', 'college_code', 'college_name', 'branch_code', 'branch_name'];

  // ❗ Prevent opening model while data still loading
  if (
    !Array.isArray(y25cutoff) ||
    !Array.isArray(y24cutoff) ||
    !Array.isArray(y23cutoff) ||
    !Array.isArray(y22cutoff) ||
    !Array.isArray(y21cutoff) ||
    !Array.isArray(y20cutoff) ||
    !Array.isArray(y19cutoff)
  ) {
    console.warn("Year data still loading. Please wait.");
    return;
  }

  if (!notAllowedColumns.includes(field) && field.startsWith('y2025')) {
    const { college_code, branch_code, college_name, branch_name } = row;

    setcurCollege(college_name);
    setcurbranch(branch_name);

    if (!college_code || !branch_code) {
      console.error('college_code or branch_code missing');
      setData([0, 0, 0, 0, 0, 0, 0]);
      setModelOpen(true);
      return;
    }

    // Extract category: OC/BC/BCM/SC/ST etc.
    const categoryValue = field.substring(field.indexOf("y2025_") + 6, field.lastIndexOf("_"));
    setcurcategory(categoryValue);

    // Set field type: cutoff or rank
    setcurfield(field.endsWith('cutoff') ? 'Cutoff' : 'Rank');

    // -------------------------------
    // ALL YEAR LISTS
    // -------------------------------
    const cutoffData = [
      { year: '2025', list: y25cutoff },     // FIXED (you had y24cutoff mistakenly)
      { year: '2024', list: y24cutoff },
      { year: '2023', list: y23cutoff },
      { year: '2022', list: y22cutoff },
      { year: '2021', list: y21cutoff },
      { year: '2020', list: y20cutoff },
      { year: '2019', list: y19cutoff }
    ];

    // -------------------------------
    // BUILD DYNAMIC YEAR FIELDS
    // -------------------------------
    const yearFields = cutoffData.map(data => {
      return field.endsWith('cutoff')
        ? `y${data.year}_${categoryValue}_cutoff`
        : `y${data.year}_${categoryValue}_rank`;
    });

    // -------------------------------
    // FIND ALL YEAR VALUES
    // -------------------------------
    const collegeBranchValues = cutoffData.map((data, index) => {
      const yearField = yearFields[index];
      const list = data.list;

      // SAFE find (prevents undefined errors)
      const item = Array.isArray(list)
        ? list.find(i => i.college_code === college_code && i.branch_code === branch_code)
        : null;

      return {
        year: data.year,
        value: item && item[yearField] !== undefined ? item[yearField] : 0
      };
    });

    // Sort by year
    collegeBranchValues.sort((a, b) => Number(a.year) - Number(b.year));

    // Convert 0 → null
    const values = collegeBranchValues.map(item => {
      return (item.value === 0 || item.value === 0.0) ? null : item.value;
    });

    const nonZero = values.filter(v => v !== null && v !== "");

    // Compute average safely
    const average =
      nonZero.length > 0
        ? nonZero.reduce((sum, v) => sum + v, 0) / nonZero.length
        : null;

    // Set chart data
    setData(values);

    if (average !== null) {
      setSubData(Array(7).fill(average));
    } else {
      setSubData([0, 0, 0, 0, 0, 0, 0]);
      console.error('No valid values found');
    }

    setModelOpen(true);
  }
};

  const handleClose = () => setModelOpen(false);
  const open = Boolean(anchorEl);

const fetchEligibility = async () => {
  setInitialLoading(true);
  setLoading(true);

  const URL = "https://api.xift.in:4656/";

  try {
    const requests = [
      api.get(`${URL}Y2024Cutoff/list`).catch(() => ({ data: [] })),
      api.get(`${URL}Y2023Cutoff/list`).catch(() => ({ data: [] })),
      api.get(`${URL}Y2022Cutoff/list`).catch(() => ({ data: [] })),
      api.get(`${URL}Y2021Cutoff/list`).catch(() => ({ data: [] })),
      api.get(`${URL}Y2020Cutoff/list`).catch(() => ({ data: [] })),
       api.get(`${URL}Y2019Cutoff/list`).catch(() => ({ data: [] })),
      // axios.get("/api/eligibility").catch(() => ({ data: [] }))
    ];

    const [
      y24, y23, y22, y21, y20, y19, eligibility
    ] = await Promise.all(requests);

    sety24cutoff(y24.data);
    sety23cutoff(y23.data);
    sety22cutoff(y22.data);
    sety21cutoff(y21.data);
    sety20cutoff(y20.data);
    sety19cutoff(y19.data);

    setEligibilityData(eligibility.data);

  } catch (err) {
    // console.error("API Error:", err);
  } finally {
    setLoading(false);
    setInitialLoading(false);
  }
};

//  console.log("eligibility:", eligibilityData);
// console.log("initialLoading:", initialLoading);
  
  useEffect(() => {
     
  fetchEligibility();


    api.get('branches')
      .then(response => {
        const branches = response.data;
        const branchCodes = branches.map(branch => ({
          label: branch.branch_code,
          value: branch.branch_code
        }));
        setBranchCode(branchCodes);

        const branchNames = branches.map(branch => ({
          label: branch.branch_name,
          value: branch.branch_name
        }));
        setBranchName(branchNames);
      })
      .catch(error => {
        console.error('Error fetching branches: ', error);
      });

    api.get('colleges')
      .then(response => {
        const colleges = response.data;
        const collegeCodes = colleges.map(college => ({
          label: college.college_code,
          value: college.college_code
        }));
        setCollegeCode(collegeCodes);

        const collegeNames = colleges.map(college => ({
          label: college.college_name,
          value: college.college_name
        }));
        setCollegeName(collegeNames);
      })
      .catch(error => {
        console.error('Error fetching colleges: ', error);
      });
        // Helper function to format cutoff values to one decimal place
        const formatCutoff = (value) => {
          return value !== null && value !== undefined && value!==0 ? parseFloat(value.toFixed(1)):"";
        };
        // Helper function to format rank values to whole integers
        const formatRank = (value) => {
          return value !== null && value !== undefined && value!==0? Math.round(value) :"";
        };
// console.log("loading:", loading);
api.get('Y2024Cutoff/list')
  .then(response => {
    const array = response.data;
    setLoading(true);

    const categories = [
      "OC", "BC", "BCM", "MBC", "SC", "SCA", "ST", "MBCDNC", "MBCV"
    ];

    // ONE SINGLE CLEAN MAPPING – gives both 2024 + 2025 values
    const mappedRows = array.map(item => {
      const base = {
        id: item.id,
        college_code: item.college_branch.college_code,
        college_name: item.college_branch.college_name,
        branch_name: item.college_branch.branch_name,
        branch_code: item.college_branch.branch_code,
        college_district: item.college_branch.clg_district,
        college_pincode: item.college_branch.clg_pincode,
      };

      categories.forEach(cat => {
        const cutoff = formatCutoff(item[`y2024_${cat}_cutoff`]);
        const rank = formatRank(item[`y2024_${cat}_rank`]);

        base[`y2024_${cat}_cutoff`] = cutoff;
        base[`y2024_${cat}_rank`] = rank;

        // Auto-generate 2025 from 2024 (same values)
        base[`y2025_${cat}_cutoff`] = cutoff;
        base[`y2025_${cat}_rank`] = rank;
      });

      return base;
    });

    if (cursorloading) {
      sety25cutoff(mappedRows);     // 2025 values
      sety24cutoff(mappedRows);     // 2024 values also included
      setFilteredCutoffList(mappedRows);
      setcursorLoading(false);
    }
  })
  .catch(error => {
    console.log('Error fetching 2024 cutoff: ', error);
    setcursorLoading(false);
  });
// console.log("y25:", y25cutoff);

        api.get('Y2023Cutoff/list')
        .then(response => {
          const array = response.data;
          setLoading(true);
          const row = array.map(item => ({
            id: item.id,
            college_code: item.college_branch.college_code,
            college_name: item.college_branch.college_name,
            branch_name: item.college_branch.branch_name,
            branch_code: item.college_branch.branch_code,
            college_district: item.college_branch.clg_district,
            college_pincode: item.college_branch.clg_pincode,
            y2023_OC_cutoff: formatCutoff(item.y2023_OC_cutoff),
            y2023_OC_rank: formatRank(item.y2023_OC_rank),
            y2023_BC_cutoff: formatCutoff(item.y2023_BC_cutoff),
            y2023_BC_rank: formatRank(item.y2023_BC_rank),
            y2023_BCM_cutoff: formatCutoff(item.y2023_BCM_cutoff),
            y2023_BCM_rank: formatRank(item.y2023_BCM_rank),
            y2023_MBC_cutoff: formatCutoff(item.y2023_MBC_cutoff),
            y2023_MBC_rank: formatRank(item.y2023_MBC_rank),
            y2023_SC_cutoff: formatCutoff(item.y2023_SC_cutoff),
            y2023_SC_rank: formatRank(item.y2023_SC_rank),
            y2023_SCA_cutoff: formatCutoff(item.y2023_SCA_cutoff),
            y2023_SCA_rank: formatRank(item.y2023_SCA_rank),
            y2023_ST_cutoff: formatCutoff(item.y2023_ST_cutoff),
            y2023_ST_rank: formatRank(item.y2023_ST_rank),
            y2023_MBCDNC_cutoff: formatCutoff(item.y2023_MBCDNC_cutoff),
            y2023_MBCDNC_rank: formatRank(item.y2023_MBCDNC_rank),
            y2023_MBCV_cutoff: formatCutoff(item.y2023_MBCV_cutoff),
            y2023_MBCV_rank: formatRank(item.y2023_MBCV_rank)
          }));
          if (cursorloading) {
            sety23cutoff(row);
            setFilteredCutoffList(row);
            setcursorLoading(false);
          }
          })
        .catch(error => {
          console.log('Error fetching 2023 cutoff: ', error);
          setcursorLoading(false);
        });
     
      api.get('Y2022Cutoff/list')
      .then(response => {const array = response.data;
        const row = array.map(item => ({
          id: item.id,
          college_code: item.college_branch.college_code,
          college_name: item.college_branch.college_name,
          branch_name: item.college_branch.branch_name,
          branch_code: item.college_branch.branch_code,
          college_district: item.college_branch.clg_district,
          college_pincode: item.college_branch.clg_pincode,
          y2022_OC_cutoff: item.y2022_OC_cutoff,
          y2022_OC_rank: item.y2022_OC_rank,
          y2022_BC_cutoff: item.y2022_BC_cutoff,
          y2022_BC_rank: item.y2022_BC_rank,
          y2022_BCM_cutoff: item.y2022_BCM_cutoff,
          y2022_BCM_rank: item.y2022_BCM_rank,
          y2022_MBC_cutoff: item.y2022_MBC_cutoff,
          y2022_MBC_rank: item.y2022_MBC_rank,
          y2022_SC_cutoff: item.y2022_SC_cutoff,
          y2022_SC_rank: item.y2022_SC_rank,
          y2022_SCA_cutoff: item.y2022_SCA_cutoff,
          y2022_SCA_rank: item.y2022_SCA_rank,
          y2022_ST_cutoff: item.y2022_ST_cutoff,
          y2022_ST_rank: item.y2022_ST_rank,
          y2022_MBCDNC_cutoff: item.y2022_MBCDNC_cutoff,
          y2022_MBCDNC_rank: item.y2022_MBCDNC_rank,
          y2022_MBCV_cutoff: item.y2022_MBCV_cutoff,
          y2022_MBCV_rank: item.y2022_MBCV_rank
        }));
        sety22cutoff(row)})
      .catch(error => {
        console.log('Error fetching 2022 cutoff: ', error);
        setcursorLoading(false);
      });

      api.get('Y2021Cutoff/list')
      .then(response => {const array = response.data;
        const row = array.map(item => ({
        id: item.id,
        college_code: item.college_branch.college_code,
        college_name: item.college_branch.college_name,
        branch_name: item.college_branch.branch_name,
        branch_code: item.college_branch.branch_code,
        college_district: item.college_branch.clg_district,
        college_pincode: item.college_branch.clg_pincode,
        y2021_OC_cutoff: item.y2021_OC_cutoff,
        y2021_OC_rank: item.y2021_OC_rank,
        y2021_BC_cutoff: item.y2021_BC_cutoff,
        y2021_BC_rank: item.y2021_BC_rank,
        y2021_BCM_cutoff: item.y2021_BCM_cutoff,
        y2021_BCM_rank: item.y2021_BCM_rank,
        y2021_MBC_cutoff: item.y2021_MBC_cutoff,
        y2021_MBC_rank: item.y2021_MBC_rank,
        y2021_SC_cutoff: item.y2021_SC_cutoff,
        y2021_SC_rank: item.y2021_SC_rank,
        y2021_SCA_cutoff: item.y2021_SCA_cutoff,
        y2021_SCA_rank: item.y2021_SCA_rank,
        y2021_ST_cutoff: item.y2021_ST_cutoff,
        y2021_ST_rank: item.y2021_ST_rank,
        y2021_MBCDNC_cutoff: item.y2021_MBCDNC_cutoff,
        y2021_MBCDNC_rank: item.y2021_MBCDNC_rank,
        y2021_MBCV_cutoff: item.y2021_MBCV_cutoff,
        y2021_MBCV_rank: item.y2021_MBCV_rank
      }));
      sety21cutoff(row)})
      .catch(error => {
        console.log('Error fetching 2021 cutoff: ', error);
        setcursorLoading(false);
      });

      api.get('Y2020Cutoff/list')
      .then(response => {
        const array = response.data;
        const row = array.map(item => ({
                  id: item.id,
                  college_code: item.college_branch.college_code,
                  college_name: item.college_branch.college_name,
                  branch_name: item.college_branch.branch_name,
                  branch_code: item.college_branch.branch_code,
                  college_district: item.college_branch.clg_district,
                  college_pincode: item.college_branch.clg_pincode,
                  y2020_OC_cutoff: item.y2020_OC_cutoff,
                  y2020_OC_rank: item.y2020_OC_rank,
                  y2020_BC_cutoff: item.y2020_BC_cutoff,
                  y2020_BC_rank: item.y2020_BC_rank,
                  y2020_BCM_cutoff: item.y2020_BCM_cutoff,
                  y2020_BCM_rank: item.y2020_BCM_rank,
                  y2020_MBC_cutoff: item.y2020_MBC_cutoff,
                  y2020_MBC_rank: item.y2020_MBC_rank,
                  y2020_SC_cutoff: item.y2020_SC_cutoff,
                  y2020_SC_rank: item.y2020_SC_rank,
                  y2020_SCA_cutoff: item.y2020_SCA_cutoff,
                  y2020_SCA_rank: item.y2020_SCA_rank,
                  y2020_ST_cutoff: item.y2020_ST_cutoff,
                  y2020_ST_rank: item.y2020_ST_rank,
                  y2020_MBCDNC_cutoff: item.y2020_MBCDNC_cutoff,
                  y2020_MBCDNC_rank: item.y2020_MBCDNC_rank,
                  y2020_MBCV_cutoff: item.y2020_MBCV_cutoff,
                  y2020_MBCV_rank: item.y2020_MBCV_rank
                }));
                sety20cutoff(row)})
      .catch(error => {
        console.log('Error fetching 2020 cutoff: ', error);
        setcursorLoading(false);
      });

      api.get('Y2019Cutoff/list')
      .then(response => {const array = response.data;
        const row = array.map(item => ({
                  id: item.id,
                  college_code: item.college_branch.college_code,
                  college_name: item.college_branch.college_name,
                  branch_name: item.college_branch.branch_name,
                  branch_code: item.college_branch.branch_code,
                  college_district: item.college_branch.clg_district,
                  college_pincode: item.college_branch.clg_pincode,
                  y2019_OC_cutoff: item.y2019_OC_cutoff,
                  y2019_OC_rank: item.y2019_OC_rank,
                  y2019_BC_cutoff: item.y2019_BC_cutoff,
                  y2019_BC_rank: item.y2019_BC_rank,
                  y2019_BCM_cutoff: item.y2019_BCM_cutoff,
                  y2019_BCM_rank: item.y2019_BCM_rank,
                  y2019_MBC_cutoff: item.y2019_MBC_cutoff,
                  y2019_MBC_rank: item.y2019_MBC_rank,
                  y2019_SC_cutoff: item.y2019_SC_cutoff,
                  y2019_SC_rank: item.y2019_SC_rank,
                  y2019_SCA_cutoff: item.y2019_SCA_cutoff,
                  y2019_SCA_rank: item.y2019_SCA_rank,
                  y2019_ST_cutoff: item.y2019_ST_cutoff,
                  y2019_ST_rank: item.y2019_ST_rank,
                  y2019_MBCDNC_cutoff: item.y2019_MBCDNC_cutoff,
                  y2019_MBCDNC_rank: item.y2019_MBCDNC_rank,
                  y2019_MBCV_cutoff: item.y2019_MBCV_cutoff,
                  y2019_MBCV_rank: item.y2019_MBCV_rank
                }));
                sety19cutoff(row)})
      .catch(error => {
        console.log('Error fetching 2019 cutoff: ', error);
        setcursorLoading(false);
      });

      
  }, []);

  const handlePopoverOpen = (event) => {
    const field = event.currentTarget.dataset.field;
    const id = event.currentTarget.parentElement.dataset.id;
    if(field != 'id' && field != 'college_code'&& field != 'college_name' && field != 'branch_code' && field != 'branch_name')
    setAnchorEl(event.currentTarget);
  };  

    const handlePopoverClose = () => {
      setAnchorEl(null);
    };

  const handleSearch = () => {
    if (!cursorloading){
    setError(false);
    if (((selectCutoff !== null && selectCutoff !== '') || (selectRank !== null && selectRank !== '')) && (selectCategory === null || selectCategory === '')) {
      setError(true);
      return;
    }

  
  const filteredRows = (y24cutoff ?? []).filter(row => {

  // Ensure filters are always arrays
  const collegeName = Array.isArray(selectCollegeName) ? selectCollegeName : [];
  const collegeCode = Array.isArray(selectCollegeCode) ? selectCollegeCode : [];
  const branchName = Array.isArray(selectBranchName) ? selectBranchName : [];
  const branchCode = Array.isArray(selectBranchCode) ? selectBranchCode : [];
  const districtList = Array.isArray(selectDistrict) ? selectDistrict : [];

  const isCollegeNameMatch =
    collegeName.length === 0 ||
    collegeName.some(c => c?.value === row.college_name);

  const isCollegeCodeMatch =
    collegeCode.length === 0 ||
    collegeCode.some(c => c?.value === row.college_code);

  const isBranchNameMatch =
    branchName.length === 0 ||
    branchName.some(b => b?.value === row.branch_name);

  const isBranchCodeMatch =
    branchCode.length === 0 ||
    branchCode.some(c => c?.value === row.branch_code);

  const isDistrictMatch =
    districtList.length === 0 ||
    districtList.some(d => d?.value === row.college_district);

  // PINCODE
  const rowPin3 = row.college_pincode?.substring(0, 3);
  const selPin3 = selectPincode?.substring(0, 3);
  const isPincodeMatch =
    !selectPincode || rowPin3 === selPin3;


  // CATEGORY CUTOFF MATCH
  let isCategoryMatch = true;
  if (selectCategory && selectCutoff !== null) {
    const v = selectCutoff;

    switch (selectCategory) {
      case "oc": isCategoryMatch = row.y2024_OC_cutoff <= v; break;
      case "bc": isCategoryMatch = row.y2024_BC_cutoff <= v; break;
      case "bcm": isCategoryMatch = row.y2024_BCM_cutoff <= v; break;
      case "mbc": isCategoryMatch = row.y2024_MBC_cutoff <= v; break;
      case "sc": isCategoryMatch = row.y2024_SC_cutoff <= v; break;
      case "sca": isCategoryMatch = row.y2024_SCA_cutoff <= v; break;
      case "st": isCategoryMatch = row.y2024_ST_cutoff <= v; break;
      case "mbcdnc": isCategoryMatch = row.y2024_MBCDNC_cutoff <= v; break;
      case "mbcv": isCategoryMatch = row.y2024_MBCV_cutoff <= v; break;
      default: isCategoryMatch = true;
    }
  }

  // CATEGORY RANK MATCH
  let isRankMatch = true;
  if (selectCategory && selectRank !== null) {
    const r = selectRank;

    switch (selectCategory) {
      case "oc": isRankMatch = row.y2024_OC_rank >= r; break;
      case "bc": isRankMatch = row.y2024_BC_rank >= r; break;
      case "bcm": isRankMatch = row.y2024_BCM_rank >= r; break;
      case "mbc": isRankMatch = row.y2024_MBC_rank >= r; break;
      case "sc": isRankMatch = row.y2024_SC_rank >= r; break;
      case "sca": isRankMatch = row.y2024_SCA_rank >= r; break;
      case "st": isRankMatch = row.y2024_ST_rank >= r; break;
      case "mbcdnc": isRankMatch = row.y2024_MBCDNC_rank >= r; break;
      case "mbcv": isRankMatch = row.y2024_MBCV_rank >= r; break;
      default: isRankMatch = true;
    }
  }

  return (
    isCollegeNameMatch &&
    isCollegeCodeMatch &&
    isBranchNameMatch &&
    isBranchCodeMatch &&
    isDistrictMatch &&
    isPincodeMatch &&
    isCategoryMatch &&
    isRankMatch
  );
})

// SORT RESULTS
.sort((a, b) => {

  if (!selectCategory) {
    return b.y2024_OC_cutoff - a.y2024_OC_cutoff;
  }

  if (selectCutoff !== null) {
    switch (selectCategory) {
      case "oc": return b.y2024_OC_cutoff - a.y2024_OC_cutoff;
      case "bc": return b.y2024_BC_cutoff - a.y2024_BC_cutoff;
      case "bcm": return b.y2024_BCM_cutoff - a.y2024_BCM_cutoff;
      case "mbc": return b.y2024_MBC_cutoff - a.y2024_MBC_cutoff;
      case "sc": return b.y2024_SC_cutoff - a.y2024_SC_cutoff;
      case "sca": return b.y2024_SCA_cutoff - a.y2024_SCA_cutoff;
      case "st": return b.y2024_ST_cutoff - a.y2024_ST_cutoff;
      case "mbcdnc": return b.y2024_MBCDNC_cutoff - a.y2024_MBCDNC_cutoff;
      case "mbcv": return b.y2024_MBCV_cutoff - a.y2024_MBCV_cutoff;
      default: return 0;
    }
  }

  if (selectRank !== null) {
    switch (selectCategory) {
      case "oc": return a.y2024_OC_rank - b.y2024_OC_rank;
      case "bc": return a.y2024_BC_rank - b.y2024_BC_rank;
      case "bcm": return a.y2024_BCM_rank - b.y2024_BCM_rank;
      case "mbc": return a.y2024_MBC_rank - b.y2024_MBC_rank;
      case "sc": return a.y2024_SC_rank - b.y2024_SC_rank;
      case "sca": return a.y2024_SCA_rank - b.y2024_SCA_rank;
      case "st": return a.y2024_ST_rank - b.y2024_ST_rank;
      case "mbcdnc": return a.y2024_MBCDNC_rank - b.y2024_MBCDNC_rank;
      case "mbcv": return a.y2024_MBCV_rank - b.y2024_MBCV_rank;
      default: return 0;
    }
  }

  return 0;
});

setDisplayGrid(true);
setFilteredCutoffList(filteredRows);
    }};

  const handleReset = () => {
    if (!cursorloading){
    setDisplayGrid(false);
    setSelectCategory(null);
    setSelectCutoff(null);
    setSelectRank(null);
    setSelectCollegeCode([]);
    setSelectCollegeName([]);
    setSelectBranchCode([]);
    setSelectBranchName([]);
    setSelectDistrict([]);
    setSelectPincode('');
    setFilteredCutoffList(cutoffList);
    setError(false);
  }
  };

return (
  <Box>

    {/* ===========================
        🔵 INITIAL IMAGE LOADER
       =========================== */}
    {initialLoading ? (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="60vh"
      >
        <img
          src={loadingImg}
          alt="Loading..."
          style={{ width: 600, height: 400 }}
          className="animate-pulse"
        />
      </Box>
    ) : (
      <>
        {/* ===========================
            🔵 MAIN INPUT FORM SECTION
           =========================== */}
        {isSmallScreen ? (
          <Box
            component="form"
            sx={{
              marginLeft: { xs: 0, sm: 5, md: 15 },
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <FormControl sx={style.formControlOther}>
            <label className="label-text">Category</label>
            <Select
              value={selectCategory || ''}
              onChange={(e) => setSelectCategory(e.target.value)}
              displayEmpty
              input={<OutlinedInput />}
              sx={style.inputFiled}
            >
              {catergory.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={style.formControlCutoffRank}>
            <label className="label-text">Cutoff</label>
            <OutlinedInput
              value={selectCutoff || ''}
              onChange={(e) => setSelectCutoff(e.target.value)}
              sx={style.inputFiled}
              type="number"
            />
          </FormControl>
          <FormControl sx={style.formControlCutoffRank}>
            <label className="label-text">Rank</label>
            <OutlinedInput
              value={selectRank || ''}
              onChange={(e) => setSelectRank(e.target.value)}
              sx={style.inputFiled}
              type="number"
            />
          </FormControl>
          <FormControl sx={style.formControlFullWidth}>
            <label className="label-text" >College Name</label>
            <MultiSelect
              options={collegeName}
              value={selectCollegeName}
              onChange={setSelectCollegeName}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControl}>
            <label className="label-text">College Code</label>
            <MultiSelect
              options={collegeCode}
              value={selectCollegeCode}
              onChange={setSelectCollegeCode}
              labelledBy="Select"
            />
          </FormControl>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <FormControl sx={style.formControlFullWidth}>
            <label className="label-text">Branch Name</label>
            <MultiSelect
              options={branchName}
              value={selectBranchName}
              onChange={setSelectBranchName}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControl}>
            <label className="label-text">Branch Code</label>
            <MultiSelect
              options={branchCode}
              value={selectBranchCode}
              onChange={setSelectBranchCode}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControlOther}>
            <label className="label-text">District</label>
            <MultiSelect
            className="label-text"
              options={district}
              value={selectDistrict}
              onChange={setSelectDistrict}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControlOther}>
            <label className="label-text">Pin Code</label>
            <OutlinedInput
              value={selectPincode}
              onChange={(e) => setSelectPincode(e.target.value)}
              sx={style.inputFiled}
              type="number"
            />
          </FormControl>
          <Box display="flex" alignItems="center" ml={1.5} mb={-2} sx={{marginLeft:isSmallScreen?'72px':'5px'}}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              sx={{ m: 1,width: '110px',height:'40px',backgroundColor:'#e9c426',color:'#000000' }}
              style={{ cursor: cursorloading ? 'wait !important' : 'default' }}
              disabled={cursorloading}
            >
              Search
            </Button>
            <Button
              variant="contained"
              onClick={handleReset}
              sx={{ m: 1,width: '110px',height:'40px',backgroundColor:'#e9c426',color:'#000000' }}
              style={{ cursor: cursorloading ? 'wait !important' : 'default' }}
              disabled={cursorloading}
            >
              Clear
            </Button>
          </Box>
        </div>
          </Box>
        ) : (
          <Box
            component="form"
            sx={{
              marginLeft: { xs: 0, sm: 5, md: 15 },
              "& .MuiTextField-root": { m: 1, width: "25ch" },
            }}
            noValidate
            autoComplete="off"
          >
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <FormControl sx={style.formControlFullWidth}>
            <label className="label-text" >College Name</label>
            <MultiSelect
              options={collegeName}
              value={selectCollegeName}
              onChange={setSelectCollegeName}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControl}>
            <label className="label-text">College Code</label>
            <MultiSelect
              options={collegeCode}
              value={selectCollegeCode}
              onChange={setSelectCollegeCode}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControlOther}>
            <label className="label-text">Category</label>
            <Select
              value={selectCategory || ''}
              onChange={(e) => setSelectCategory(e.target.value)}
              displayEmpty
              input={<OutlinedInput />}
              sx={style.inputFiled}
            >
              {catergory.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl sx={style.formControlCutoffRank}>
            <label className="label-text">Cutoff</label>
            <OutlinedInput
              value={selectCutoff || ''}
              onChange={(e) => setSelectCutoff(e.target.value)}
              sx={style.inputFiled}
              type="number"
            />
          </FormControl>
          <FormControl sx={style.formControlCutoffRank}>
            <label className="label-text">Rank</label>
            <OutlinedInput
              value={selectRank || ''}
              onChange={(e) => setSelectRank(e.target.value)}
              sx={style.inputFiled}
              type="number"
            />
          </FormControl>
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <FormControl sx={style.formControlFullWidth}>
            <label className="label-text">Branch Name</label>
            <MultiSelect
              options={branchName}
              value={selectBranchName}
              onChange={setSelectBranchName}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControl}>
            <label className="label-text">Branch Code</label>
            <MultiSelect
              options={branchCode}
              value={selectBranchCode}
              onChange={setSelectBranchCode}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControlOther}>
            <label className="label-text">District</label>
            <MultiSelect
              options={district}
              value={selectDistrict}
              onChange={setSelectDistrict}
              labelledBy="Select"
            />
          </FormControl>
          <FormControl sx={style.formControlOther}>
            <label className="label-text">Pin Code</label>
            <OutlinedInput
              value={selectPincode}
              onChange={(e) => setSelectPincode(e.target.value)}
              sx={style.inputFiled}
              type="number"
            />
          </FormControl>
          <Box display="flex" alignItems="center" ml={1.5} mb={-2} sx={{marginLeft:isSmallScreen?'72px':'5px'}}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSearch}
              sx={{ m: 1,width: '110px',height:'40px',backgroundColor:'#e9c426',color:'#000000' }}
              className= {cursorloading ? 'button-eventnone' : 'button-event'}
            >
              Search
            </Button>
            <Button
              variant="contained"
              onClick={handleReset}
              sx={{ m: 1,width: '110px',height:'40px',backgroundColor:'#e9c426',color:'#000000' }}
              className= {cursorloading ? 'button-eventnone' : 'button-event'}
            >
              Clear
            </Button>
          </Box>
        </div>

          </Box>
        )}

        {/* ===========================
            🔵 TABLE SECTION (SHOWN AFTER LOAD)
           =========================== */}
        <TableContainer sx={{ overflowX: "auto", width: "100%" }}>
  {displayGrid ? (
    loading ? (
      <Box
        sx={{
          height: 678,
          width: isSmallScreen ? "96.5%" : "98.5%",   // <-- FIXED HERE
          mt: 4,
          ml: isSmallScreen ? 1 : 2,
          overflowX: "auto",                         // <-- NEW FIX
        }}
      >
        <DataGrid
          rows={filteredCutoffList}
          onCellClick={handleOpen}
          columns={columns}
          disableSelectionOnClick={disablecolumns}
          rowHeight={100}
          getRowHeight={() => "auto"}
          initialState={{
            pagination: { paginationModel: { pageSize: 9 } },
          }}
          pageSizeOptions={[9]}
       

                  sx={{
                    "& .MuiDataGrid-columnHeaderTitle": {
                      whiteSpace: "normal",
                      lineHeight: "normal",
                      textAlign: "center",
                    },
                    "& .MuiDataGrid-columnHeader": { height: "50px" },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: grey[200],
                      fontWeight: "bold",
                    },
                    "& .super-app-theme--header": {
                      backgroundColor: "#e9c426",
                      color: "#000",
                      fontWeight: "bold",
                    },
                  }}
                 />

               <Popover
        sx={{
          pointerEvents: 'none',
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >

         <Box sx={{ width:' 70px',height:'45px',flexGrow: 1 }}>
          {/* Hello everyone come to my home */}
          <SparkLineChart
            data={[160, 164, 172, 159, 175, 185, 190]}
            height={45}
            showHighlight={true}
            showTooltip={true}
          />
      </Box>
      </Popover>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={modelopen}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={modelopen}>
          <ModalContent sx={style.model}>
          <Box sx={{display:'flex',fontSize:isSmallScreen?'18px':'21px'}}>
            <Box id="transition-modal-title" className="modal-title" >
             {curcategory}  {curfield}  Analysis
            </Box>
            <Box sx={{fontSize:'18px',marginTop:'3px',marginLeft:isSmallScreen?'0.5px':'5px'}}>( 2019 - 2025 )  </Box>
            </Box>
            <Box sx={{ width:'100%',height:'100%',flexGrow: 1 }}>
            <LineChart
              xAxis={[{  scaleType: 'band',data: ['2019','2020','2021','2022','2023','2024','2025'] }]}
              series={[
                {
                  data:data,
                  label:curfield,
                  connectNulls,
                },
                {
                  data:subdata,
                  showMark: false,
                  label: 'Average',

                },
              ]}
              width={isSmallScreen?320:500}
              height={300}
            />
          </Box>
          <Box style={{ fontSize: '15px', maxWidth: isSmallScreen?'350px':'500px', wordWrap: 'break-word',textAlign:'center' }}>{curbranch} </Box>
          <Box style={{ fontSize: '15px', maxWidth:isSmallScreen?'350px':'500px', wordWrap: 'break-word',textAlign:'center' }}>{curcollege} </Box>
          </ModalContent>
        </Fade>
      </Modal>

              </Box>
            ) : (
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                height="50vh"
              >
                <CircularProgress />
              </Box>
            )
          ) : null}
        </TableContainer>
      </>
    )}
  </Box>
);
}
export default Eligibility;
